var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector 8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0303 0H1C0.447715 0 0 0.447715 0 1V16C0 16.5523 0.447715 17 1 17H3.0303C3.58259 17 4.0303 16.5523 4.0303 16V1C4.0303 0.447715 3.58259 0 3.0303 0Z",
    fill: "#BAB7AF",
    fillOpacity: 0.948,
    className: "svg-primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.991 0.84189L11.8862 1.43374C11.3608 1.5815 11.0509 2.12331 11.1899 2.65113L14.7107 16.0168C14.853 16.5572 15.4105 16.876 15.9484 16.7248L18.0531 16.1329C18.5786 15.9852 18.8885 15.4434 18.7495 14.9155L15.2287 1.54982C15.0863 1.00949 14.5289 0.690631 13.991 0.84189Z",
    fill: "#BAB7AF",
    fillOpacity: 0.948,
    className: "svg-primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78788 0H6.75758C6.20529 0 5.75758 0.447715 5.75758 1V8.5V16C5.75758 16.5523 6.20529 17 6.75758 17H8.78788C9.34016 17 9.78788 16.5523 9.78788 16V1C9.78788 0.447715 9.34016 0 8.78788 0Z",
    fill: "#BAB7AF",
    fillOpacity: 0.948,
    className: "svg-primary"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.546a5fa8.svg";
export { ForwardRef as ReactComponent };